export const sanitizeString = (text: string) => {
  return text.replace(/([\uF0B7]+)/gi, '');
};
